import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import http from "../Utils/axiosConfig";
import { apiMessage } from "../Utils/apiMessage";
import "./MemberRegister/Main/Dashboard.css";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setApiError("");
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.currentPassword) newErrors.currentPassword = "सध्याचा पासवर्ड आवश्यक आहे";
    if (!formData.newPassword) newErrors.newPassword = "नवीन पासवर्ड आवश्यक आहे";
    else if (formData.newPassword.length < 6) newErrors.newPassword = "पासवर्ड किमान 6 अक्षरांचा असावा";
    if (!formData.confirmPassword) newErrors.confirmPassword = "पासवर्ड पुन्हा टाका";
    else if (formData.newPassword !== formData.confirmPassword)
      newErrors.confirmPassword = "पासवर्ड जुळत नाही";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await http.post("login/change-password", {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });
      if (res.code === "PASSWORD_CHANGED") {
        setSuccess(true);
        setTimeout(() => {
          localStorage.clear();
          navigate("/");
        }, 2500);
      } else {
        setApiError(apiMessage(res, "पासवर्ड बदलणे अयशस्वी"));
      }
    } catch (err) {
      setApiError(apiMessage());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <div className="change-password-box">
        <div className="change-password-icon">
          <i className="fa-solid fa-lock"></i>
        </div>
        <h2 className="change-password-title">पासवर्ड बदला</h2>

        {success ? (
          <div className="change-password-success">
            <i className="fa-solid fa-circle-check"></i>
            <p>पासवर्ड यशस्वीरित्या बदलला ✅</p>
            <p className="change-password-redirect">लॉगिन पृष्ठावर नेले जात आहे...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="change-password-form">
            <div className="cp-field">
              <label>सध्याचा पासवर्ड</label>
              <input
                type="password"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                placeholder="Current password"
              />
              {errors.currentPassword && <p className="cp-error">{errors.currentPassword}</p>}
            </div>

            <div className="cp-field">
              <label>नवीन पासवर्ड</label>
              <input
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                placeholder="New password"
              />
              {errors.newPassword && <p className="cp-error">{errors.newPassword}</p>}
            </div>

            <div className="cp-field">
              <label>पासवर्ड पुन्हा टाका</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm new password"
              />
              {errors.confirmPassword && <p className="cp-error">{errors.confirmPassword}</p>}
            </div>

            {apiError && <p className="cp-api-error">{apiError}</p>}

            <div className="cp-actions">
              <button type="button" className="cp-btn-cancel" onClick={() => navigate("/dashboard")}>
                रद्द करा
              </button>
              <button type="submit" className="cp-btn-submit" disabled={loading}>
                {loading ? "बदलत आहे..." : "जतन करा"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ChangePassword;
